module.exports = __webpack_public_path__ + "21d5ab16aa2d1346aad4128363fef978.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owl-item-types/beak.png
// module id = 1132
// module chunks = 0